import type { CanActivateFn } from '@angular/router';
import type { Order } from '@wizbii/utils/models';

import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environment';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { Store } from '@ngrx/store';
import { userId } from '@wizbii-utils/angular/stores';
import { FibiiOrdersWebservice } from '@wizbii-utils/angular/webservices';
import { OrderStatusEnum, orderStatusSuccession } from '@wizbii/utils/models';
import { from, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

export const hasOrderGuard: CanActivateFn = () => {
  const fibiiOrdersWebservice = inject(FibiiOrdersWebservice);
  const store = inject(Store);
  const router = inject(Router);

  return store.select(userId).pipe(
    filter((userId: string | null): userId is string => !!userId),
    switchMap((userId) => fibiiOrdersWebservice.getLastOrder(userId, environment.i18n.country)),
    catchError(() => of(null)),
    switchMap((lastOrder) => {
      return redirectOnlyIfOrder(router, lastOrder);
    }),
    map((redirect) => redirect)
  );
};

const redirectOnlyIfOrder = (router: Router, lastOrder: Order | null) => {
  if (
    !lastOrder ||
    (lastOrder &&
      orderStatusSuccession[lastOrder.status] <= orderStatusSuccession[OrderStatusEnum.COUNTERPART_CONFIRMATION])
  ) {
    return from(router.navigate(['/', FeaturesRoutingEnum.Dashboard]));
  }
  return of(true);
};
